import { Box } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
import { Editor } from '@toast-ui/react-editor';
import React, { useEffect, useRef } from 'react';
import { Controller } from 'react-hook-form';
import { FormInputLabel } from './FormInputLabel';

/**
 * Toast UI Editor를 react-hook-form과 통합하는 내부 컴포넌트
 */
const EditorWithSync = ({ field, error, editorRef }) => {
  const isInitialMountRef = useRef(true);
  const lastValueRef = useRef(field.value);

  // field.value가 변경될 때 에디터 내용 업데이트
  useEffect(() => {
    if (!editorRef.current) return;

    const editorInstance = editorRef.current.getInstance();
    if (!editorInstance) return;

    // 초기 마운트 시에는 initialValue가 처리하므로 스킵
    if (isInitialMountRef.current) {
      isInitialMountRef.current = false;
      lastValueRef.current = field.value;
      return;
    }

    // 값이 실제로 변경되었을 때만 업데이트 (무한 루프 방지)
    const normalizedCurrent = lastValueRef.current?.replaceAll('<br>', '') || '';
    const normalizedFieldValue = field.value?.replaceAll('<br>', '') || '';

    if (normalizedCurrent !== normalizedFieldValue && field.value !== undefined) {
      editorInstance.setHtml(field.value || '');
      lastValueRef.current = field.value;
    }
  }, [field.value, editorRef]);

  return (
    <Editor
      initialValue={field.value || ''}
      initialEditType='wysiwyg'
      useCommandShortcut={true}
      ref={editorRef}
      style={{ border: error ? '1px solid red' : '1px solid #ccc' }}
      onChange={() => {
        if (!editorRef.current) return;

        const editorInstance = editorRef.current.getInstance();
        if (!editorInstance) return;

        const new_value = editorInstance.getHtml();
        const remove_new_value = new_value.replaceAll('<br>', '');

        // 값이 실제로 변경되었을 때만 field.onChange 호출 (무한 루프 방지)
        const currentFieldValue = field.value?.replaceAll('<br>', '') || '';
        if (remove_new_value !== currentFieldValue) {
          lastValueRef.current = remove_new_value;
          field.onChange(remove_new_value);
        }
      }}
    />
  );
};

export const FormTextEditor = React.forwardRef((props, ref) => {
  const editorRef = useRef(null);
  const { label, error, control, ...rest } = props;

  console.log('rest', rest);

  return (
    <div className='flex flex-col gap-1'>
      {label && <FormInputLabel label={label} isRequired={rest.required} />}
      <Box
        sx={{
          'border': error ? '1px solid red' : '1px solid #ccc',
          'overflow': 'hidden',
          'borderRadius': '8px',
          '& .tui-editor-defaultUI': {
            border: 'none',
          },
        }}
      >
        <Controller
          control={control}
          name={rest.name}
          rules={rest.rules}
          render={({ field }) => <EditorWithSync field={field} error={error} editorRef={editorRef} />}
        />
      </Box>
      {error && <FormHelperText error>{error.message}</FormHelperText>}
    </div>
  );
});

FormTextEditor.displayName = 'FormTextEditor';
